module.exports = __webpack_public_path__ + "img/Group2.d3b912d1.svg";